export default (theme) => ({
  '@keyframes fadeToggle': {
    '0%, 100%': {
      opacity: 1, // Completamente visible
    },
    '50%': {
      opacity: 0.5, // Casi transparente (ajústalo para un efecto más o menos tenue)
    },
  },
  root: {
    width: '100%',
    height: '100%',
    minHeight: '495px',
    padding: 20,
    position: 'relative',
    background: '#F5F5F5',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
    borderRadius: theme.spacing(2),
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 12,
    display: 'inline-flex',
  },
  title: {
    width: '100%',
    height: '40px',
    position: 'relative',
  },
  titleText: {
    fontSize: '18px !important',
    fontWeight: '600 !important',
    lineHeight: 'normal !important',
    textAlign: 'left',
    fontFamily: 'Roboto, Helvetica, Arial !important',
  },
  content: {
    width: '100%',
    height: '100%',
    padding: '10px 15px',
    background:
      'linear-gradient(to bottom right, #EEEEEE 0%, #E7E7E7 50%) bottom right / 50% 50% no-repeat, linear-gradient(to bottom left, #EEEEEE 0%, #E7E7E7 50%) bottom left / 50% 50% no-repeat, linear-gradient(to top left, #EEEEEE 0%, #E7E7E7 50%) top left / 50% 50% no-repeat, linear-gradient(to top right, #EEEEEE 0%, #E7E7E7 50%) top right / 50% 50% no-repeat',
    boxShadow:
      'inset 0px 0px 10px rgba(0, 0, 0, 1), 0px 0px 4px rgba(0, 0, 0, 1), 0px 0px 3px rgba(107, 107, 107, 1), inset 0px 0px 3px rgba(0, 0, 0, 0.5), 0px 0px 10px rgba(0, 0, 0, 1)',
    borderRadius: 28,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(),
    display: 'inline-flex',
    '& .MuiTypography-root': {
      fontFamily: 'LCD, sans-serif !important',
      fontWeight: '700 !important',
      lineHeight: '100% !important',
    },
  },
  display: {
    height: '100%',
    width: '100%',
  },
  displayImage: {
    width: '100%',
    height: '100%',
    background:
      'linear-gradient(135deg, rgba(224, 247, 255, 0.4), rgba(112, 112, 255, 0.5))',
    boxShadow:
      'inset 0px 0px 10px rgba(0, 0, 0, 1), 0px 0px 4px rgba(0, 0, 0, 1), 0px 0px 3px rgba(107, 107, 107, 1), inset 0px 0px 3px rgba(0, 0, 0, 0.5), 0px 0px 10px rgba(0, 0, 0, 1)',
    borderRadius: theme.spacing(2),
  },
  displayTitle: {
    fontSize: '34px !important',
    fontWeight: '700 !important',
  },
  displaySubtitle: {
    fontWeight: '700 !important',
    fontSize: '24px !important',
  },
  displaySubtitle2: {
    fontWeight: '700 !important',
  },
  displayContent: {
    borderRadius: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '10px 15px',
    height: '100%',
    width: '100%',
    backgroundColor:
      'linear-gradient(to bottom right, #EEEEEE 0%, #E7E7E7 50%) bottom right / 50% 50% no-repeat, linear-gradient(to bottom left, #EEEEEE 0%, #E7E7E7 50%) bottom left / 50% 50% no-repeat, linear-gradient(to top left, #EEEEEE 0%, #E7E7E7 50%) top left / 50% 50% no-repeat, linear-gradient(to top right, #EEEEEE 0%, #E7E7E7 50%) top right / 50% 50% no-repeat',
    boxShadow:
      'inset 0px 0px 10px rgba(0, 0, 0, 1), 0px 0px 4px rgba(0, 0, 0, 1), 0px 0px 3px rgba(107, 107, 107, 1), inset 0px 0px 3px rgba(0, 0, 0, 0.5), 0px 0px 10px rgba(0, 0, 0, 1)',
  },
  buttonsContent: {
    width: '100%',
    height: '70px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  buttonLeft: {
    width: 25,
    height: 40,
    transform: 'rotate(180deg)',
    background: '#D9D9D9',
    boxShadow: '0px 0px 10px rgba(28, 28, 28, 0.10) inset',
    borderTopLeftRadius: 2,
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    borderBottomLeftRadius: 2,
    position: 'relative',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0px 0px 10px rgba(28, 28, 28, 0.50) inset',
    },
  },
  buttonPlay: {
    position: 'absolute',
    top: '50%',
    right: '50%',
    transform: 'translate(50%, -50%)',
    width: 0,
    height: 0,
    borderLeft: '8px solid #666',
    borderTop: '5px solid transparent',
    borderBottom: '5px solid transparent',
    filter: 'drop-shadow(0 0 2px rgba(0,0,0,0.5))',
  },
  logo: {
    width: 96,
    height: 40,
    backgroundImage: 'url("/images/logo-metimur-negro.png")',
    backgroundPosition: `center`,
    backgroundSize: `contain`,
    backgroundRepeat: `no-repeat`,
  },
  buttonRight: {
    width: 25,
    height: 40,
    transform: 'rotate(360deg)',
    background: '#D9D9D9',
    boxShadow: '0px 0px 10px rgba(28, 28, 28, 0.10) inset',
    borderTopLeftRadius: 2,
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    borderBottomLeftRadius: 2,
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0px 0px 10px rgba(28, 28, 28, 0.50) inset',
    },
  },
  description: {
    fontFamily: 'DS-DIGIT, monospace !important',
    lineHeight: '100% !important',
    fontWeight: 700,
  },
  voltage: {
    fontFamily: 'DS-DIGIT, monospace !important',
    lineHeight: '100% !important',
    fontWeight: 700,
    fontSize: '14px !important',
  },
  ellipseGreen: {
    width: '16px',
    position: 'absolute',
    margin: '0 !important',
    top: '0px',
    right: '0px',
    boxShadow:
      '-2px -2px 3px rgba(0, 0, 0, 0.1) inset, 1px 1px 2px rgba(0, 0, 0, 0.6) inset, 0px 0px 2px rgba(0, 0, 0, 0.6)',
    borderRadius: '50%',
    backgroundColor: '#008d1a',
    height: '16px',
    animation: 'fadeToggle 1.5s infinite',
  },
  ellipseRed: {
    width: '16px',
    position: 'absolute',
    margin: '0 !important',
    top: '0px',
    right: '0px',
    boxShadow:
      '-2px -2px 3px rgba(0, 0, 0, 0.1) inset, 1px 1px 2px rgba(0, 0, 0, 0.6) inset, 0px 0px 2px rgba(0, 0, 0, 0.6)',
    borderRadius: '50%',
    backgroundColor: '#D64539',
    height: '16px',
    animation: 'fadeToggle 1.5s infinite',
  },
  button: {
    borderRadius: '999px !important',
    backgroundColor: '#e0e0e0',
    color: '#333',
    fontSize: '18px',
    fontWeight: 'bold',
    border: '1px solid #ccc',
    textShadow: '0 1px 0 rgba(255,255,255,0.5)',
    padding: '12px 24px',
    transition:
      'box-shadow 0.2s ease-out, transform 0.2s ease-out, background-color 0.2s ease-out',
    boxShadow: `
      0 1px 4px -1px rgba(255,255,255,1) inset,
      0 6px 12px 1px rgba(0,0,0,0.5),
      0 6px 2px 1px rgba(0,0,0,0.15),
      4px 4px 6px 0 rgba(0,0,0,0.05),
      -4px 4px 6px 0 rgba(0,0,0,0.05),
      inset 0 0.4em 1em rgba(0,0,0,0.1),
      inset 0 -0.4em 1em rgba(255,255,255,0.4)
    `,
    '&:hover': {
      backgroundColor: '#ebebeb',
      boxShadow: `
      0 1px 4px -1px rgba(255,255,255,0.4) inset,
      0 6px 12px 1px rgba(0,0,0,0.15),
      0 6px 2px 1px rgba(0,0,0,0.1),
      4px 4px 6px 0 rgba(0,0,0,0.05),
      -4px 4px 6px 0 rgba(0,0,0,0.05)
      `,
    },
  },
  buttonActive: {
    borderRadius: '999px !important',
    backgroundColor: '#c7c7c7',
    transform: 'scale(0.96)',
    boxShadow: `
      0 1px 4px -1px rgba(255,255,255,0.4) inset,
      0 6px 12px 1px rgba(0,0,0,0.15),
      0 6px 2px 1px rgba(0,0,0,0.1),
      4px 4px 6px 0 rgba(0,0,0,0.05),
      -4px 4px 6px 0 rgba(0,0,0,0.05)
    `,
    color: '#222',
    fontSize: '18px',
    fontWeight: 'bold',
    border: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.2s ease-in-out',
  },
  buttonText: {
    fontSize: '16px',
    fontWeight: '500',
  },
});
